import { render, staticRenderFns } from "./AdiPaiCureDomiciliariListComponent.vue?vue&type=template&id=3de0ec27"
import script from "./AdiPaiCureDomiciliariListComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiCureDomiciliariListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports